export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-24-7585745184819732b6ac565660d41e3d.png";